import type { PointData } from 'pixi.js';
import { Container } from 'pixi.js';
import { CoinPartLayout } from '../../../../layouts/common/CoinPartLayout';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';
import { interpolationMap } from '../../../libs/TweenManager/interpolations';
import MathUtils from '../../../utils/MathUtils';

export class CoinFlyParticle extends Container {
  private readonly pathFlyDuration = 600;

  private readonly layout = new CoinPartLayout();

  constructor(private readonly timeScale = 1) {
    super();

    this.layout.root.props({
      parent: this,
    });
    this.visible = false;
  }

  public async animate(startPoint: PointData, finishPoint: PointData): Promise<void> {
    await this.animateShowUp(startPoint);
    await this.wait(200 / this.timeScale);
    await this.animatePath(finishPoint);
    await this.tweenTo({ scaleXY: 0 }, 50 / this.timeScale, 'cubicIn', true).asyncOnComplete();
    this.destroy({ children: true });
  }

  private async animateShowUp(startPoint: PointData): Promise<void> {
    const scaleTo = this.scale.x;

    this.props({
      scale: 0,
      visible: true,
      position: startPoint,
    });

    void playLayoutAnimation(this.layout, 'Turn_Around', true);

    await this.tweenTo(
      { scaleXY: scaleTo, y: startPoint.y - 50, x: startPoint.x + MathUtils.getRandomValueInRange(-20, 20) },
      300 / this.timeScale,
      'cubicOut',
      true,
    ).asyncOnComplete();
  }

  private async animatePath(finishPoint: PointData): Promise<void> {
    const tweenProps = {
      x: [this.x > finishPoint.x ? this.x - 300 : this.x + 300, finishPoint.x],
      y: [this.y, finishPoint.y],
    };

    // const scaleDownDuration = 50;
    //
    // this.tweenTo({ scaleXY: 0 }, scaleDownDuration, 'expIn', true, this.pathFlyDuration - scaleDownDuration);

    await this.tweenTo(tweenProps, this.pathFlyDuration / this.timeScale, 'cubicIn', false)
      .interpolation(interpolationMap.bezier)
      .start()
      .asyncOnComplete();
  }
}
